// src/pages/Home.js
import React from 'react';
import About from '../components/About.js';

const Home = () => {
  return (
    <main className="container">
      <About />
    </main>
  );
};

export default Home;
